<template>
  <div class="static_pages_layout">
    <header class="static_pages_header">
      <router-link class="logo" to="/">
        <img
          src="@/assets/media/logo/logo.png"
          alt="Logo"
          width="120"
          height="88"
        />
      </router-link>

      <div class="header_actions">
        <button
          type="button"
          class="lang_btn"
          @click="changeAppLanguage('en')"
          v-if="getAppLocale === 'ar'"
        >
          En
        </button>
        <button
          type="button"
          class="lang_btn"
          @click="changeAppLanguage('ar')"
          v-else
        >
          ع
        </button>
      </div>
    </header>

    <main class="static_pages_content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "StaticPagesLayout",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    ...mapActions({
      changeAppLanguage: "AppLangModule/changeAppLanguage",
    }),
  },
};
</script>
